export default __webpack_public_path__ + "c39715418acfeea22dd5aa7d39233256.png";